<ng-container *ngIf="!showDone && !isLoading">
    <p-tabView orientation="right" (onChange)="selectTab($event)" [(activeIndex)]="tabIndex">
        <p-tabPanel header="Details">
            <ng-container *ngTemplateOutlet="workTypeDetailsForm"></ng-container>
        </p-tabPanel>
        <p-tabPanel header="Categories" *ngIf="viewStatus === 'edit'">
            <ng-container *ngTemplateOutlet="workTypeCategories"></ng-container>
        </p-tabPanel>
    </p-tabView>
</ng-container>

<ng-template #workTypeDetailsForm>
    <div class="cas-pad cas-flex-column-limit">
        <form [formGroup]="editForm" >
            <acabim-form-block  labelWidth="9" [colonize]="true">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Name</acabim-form-input-label>
                    <acabim-form-input-content>
                        <input formControlName="name" pInputText>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>CIB Group</acabim-form-input-label>
                    <acabim-form-input-content>
                        <p-dropdown
                            [options]="cbiGroupOptions"
                            formControlName="cbiGroup"
                            appendTo="body"
                            placeholder="Select CBI group"
                            [filter]="true"></p-dropdown>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>OmniClass</acabim-form-input-label>
                    <acabim-form-input-content>
                        <div>
                            <input formControlName="omniclass" pInputText>
                            <acabim-form-input-reset  [fieldData]="{formGroup: editForm, fieldName: 'omniclass'}"></acabim-form-input-reset>
                        </div>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper *ngIf="viewStatus !== 'add'">
                    <acabim-form-input-label>Status</acabim-form-input-label>
                    <acabim-form-input-content>
                        <p-dropdown
                            [options]="statusOptions"
                            formControlName="status"
                            optionLabel="label"
                            optionValue="value"
                            class="push-down"
                            placeholder="Status"></p-dropdown>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </acabim-form-block>
            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button (click)="cancel()">Cancel</button>
                <button *ngIf="viewStatus === 'edit'" class="cas-button-action cas-button-right" (click)="update()">Update</button>
                <button *ngIf="viewStatus === 'add'" class="cas-button-action cas-button-right" (click)="add()">Add</button>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #workTypeCategories>
    <acabim-admin-work-order-category-management
        (cancelled)="cancel()"
        [workTypeDetails]="workTypeDetails"></acabim-admin-work-order-category-management>
</ng-template>

<ng-container *ngIf="showDone && !isLoading">
    <div class="cas-info">
        <h4>Done!</h4>
        <p *ngIf="viewStatus === 'edit'">Successfully updated work type</p>
        <p *ngIf="viewStatus === 'add'">Successfully added new work type</p>
        <button class="cas-button-action" (click)="close()">Close</button>
    </div>
</ng-container>

<ng-container *ngIf="!showDone && isLoading">
    <acabim-loading-view></acabim-loading-view>
</ng-container>
